import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { IProfileWarningsResult, WarningSection } from './warnings/types'

interface IProfileWarningsSummaryProps {
  warnings: IProfileWarningsResult
}

const ProfileWarningsSummary: React.FC<IProfileWarningsSummaryProps> = ({ warnings }) => {
  const { t } = useTranslation()

  if (warnings.totalMissingFields === 0) {
    return null
  }

  const sectionLabelKeys: Record<WarningSection, string> = {
    profile: 'profile',
    skills: 'skills.title',
    industries: 'industries.title',
    roles: 'roles.title',
    employers: 'employer.title',
    projects: 'project.title',
    education: 'education.title',
    courses: 'profile.warnings.sectionLabel.courses',
    certificates: 'profile.warnings.sectionLabel.certificates',
    competences: 'profile.warnings.sectionLabel.competences',
    references: 'reference.title',
    languages: 'language.title',
  }

  const sectionsWithIssues = (Object.keys(warnings.sections) as WarningSection[]).filter(
    section => warnings.sections[section].missingFields > 0
  )

  return (
    <Alert
      severity="warning"
      data-testid="profile-warnings-summary"
      variant="filled"
      sx={{
        mb: 2,
        mt: 1,
        color: '#333333',
      }}
    >
      <Typography variant="body2" fontWeight="bold" mb={0.5}>
        {t('profile.warnings.summaryTitle', {
          count: warnings.totalMissingFields,
          sections: warnings.sectionsWithWarnings,
        })}
      </Typography>
      <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
        {sectionsWithIssues.map(section => (
          <Typography key={section} component="li" variant="body2">
            {t(sectionLabelKeys[section])}:{' '}
            {t('profile.warnings.itemCount', { count: warnings.sections[section].affectedItems })}
          </Typography>
        ))}
      </Box>
    </Alert>
  )
}

export default ProfileWarningsSummary
